import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {JwtService} from '../services/jwt.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private router: Router, private jwt: JwtService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!req.headers.has('Content-Type')) {
      req = req.clone({headers: req.headers.set('Content-Type', 'application/json')});
    }

    req = req.clone({headers: req.headers.set('Accept', 'application/json, application/pdf')});

    req = req.clone({headers: req.headers.set('Authorization', `Bearer ${localStorage.getItem('auth_token')}`)});

    if (!req.url.startsWith('http://') && !req.url.startsWith('https://')) {
      req = req.clone({url: 'http://bid3.polishop.hu'.concat(req.url)});
      // req = req.clone({url: 'http://bid.local'.concat(req.url)});
    }

    return next.handle(req).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event.headers.get('Authorization')) {
          const token = event.headers.get('Authorization').replace('Bearer ', '');
          this.jwt.setToken(token);
        }
      }
    }, (error: any) => {
      if (error instanceof HttpErrorResponse) {
        console.log(error);
        if (error.status === 401) {
          this.router.navigate(['auth/login']);
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/interceptors/jwt.interceptor.ts